import { Option } from '../option';

export class OptionsAdminAsidePage {
    public productLineId: number;
    public productLineCode: string;
    public option: Option;
    public options: Option[];
    public categoryId: number;
    public searchString: string;
    public plantNumber: number;
    public pageNumber: number;

    constructor() {
        this.productLineId = null;
        this.productLineCode = null;
        this.option = null;
        this.options = null;
        this.categoryId = null;
        this.searchString = null;
        this.plantNumber = null;
        this.pageNumber = null;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/pageloadoptions/options-admin-aside-options.ts